// @NOTE: This is a temporary HOC to ensure that the user is logged in before accessing the page
// this should be moved to container -> HOC

export function withAuth(WrappedComponent: React.ComponentType<unknown>) {
  return WrappedComponent
}
